module.exports = __webpack_public_path__ + "img/partner_partner_1.7bcd341c.png";